<template>
  <div class="certInfo">
    <Normaltop
      :url="img_url"
      title="证书发放"
      en="Certificate issuance"
    ></Normaltop>

    <div class="guide-cont">
      <div class="bg-part" ref="block0">
        <div class="part">
          <!-- <el-row :gutter="20" align="middle" type="flex">
            <el-col :span="7"> </el-col>
            <el-col :span="17"> -->
          <el-card>
            <h2 class="part-title">证书介绍</h2>
            <div class="flex-row-between flex-col-center">
              <div>
                <p class="part-cont">
                  学员需要参加统一组织的培训和考试，考试通过后，可在平台查询成绩，符合认证条件的学员将获得“生涯规划咨询师”（Career
                  Planning Consultant）认证证书。
                  目前证书由上海现代服务业联合会互联网科创专委会与国际注册理财师学会亚洲事务暨中国发展中心（RFP中国）共同颁发，学员完成学习及考试后，可以获得上述两个机构分别颁发的生涯规划咨询师证书（双证）。
                </p>
              </div>
            </div>
            <el-row align="middle" type="flex" justify="space-around">
              <el-col :span="8">
                <img src="../assets/image/cert/img1.jpg" alt
              /></el-col>
              <el-col :span="8">
                <img src="../assets/image/cert/cpc.jpg" alt />
              </el-col>
            </el-row>
          </el-card>

          <!-- </el-col>
          </el-row> -->
        </div>
      </div>
      <div class="cert_container">
        <div class="cert">
          <h2 class="part-title">查看电子证书</h2>
          <p class="part-cont">
            生涯规划咨询师与教育培训学分银行平台合作，实现证书上链。
          </p>
        </div>
        <!-- <div class="cert_btn">扫描小程序二维码查看 ></div>
        <img style="width:100%;" src="../assets/image/cert/img2.png" alt /> -->
      </div>
      <div ref="block2">
        <div class="part">
          <h2 class="part-title">认证机构</h2>

          <p class="part-cont">
            生涯规划咨询师能力水平评价系统，是由上海现代服务业联合会互联网科创服务专业委员会指导建设的技术服务平台。平台包括生涯规划咨询师技能相关的在线视频培训、能力测评考试等功能模块。项目采用《生涯规划咨询师评测标准》体系，面向全国提供生涯规划咨询师技能培训、评测认证等系列服务。
            为鼓励全国保险理财等相关行业人员提升客户服务水平，国际注册理财师学会亚洲事务暨中国发展中心（RFP中国）与上海现现代服务业联合会共同参与生涯规划咨询师的能力认证体系建设。
          </p>

          <h3 class="part-h3">发证机构介绍：</h3>
          <p class="part-cont">
            上海现代服务业联合会成立于2005年，是由上海市政府主管的、依据《上海市社会团体登记管理条例》注册成立的全市性跨行业、跨领域、非营利性、行业组织性社团。它是由上海市现代服务业领域的企事业单位、金融机构、大专院校和知名专家学者等自愿组成的社会团体，是重点服务业联合组织，目前拥有会员机构近千家。
            上海现代服务业联合会的宗旨是促进上海现代服务业的健康发展。它致力于提升中国服务业的发展水平和国际竞争力，推动上海现代服务业的发展和营商环境的优化，分析服务业发展趋势和政策规划，协调各个领域的利益关系，推动服务业创新和协同发展，搭建企业与政府、行业内外的交流合作平台。上海现代服务业联合会集聚了众多上海市重点服务业的单位。它在服务业人才培养、技术创新、企业咨询、行业标准制定和贸易促进等方面发挥着重要的作用，是推动上海现代服务业向高端、多元化、国际化发展的关键力量之一。
            <br /><br />
            RFP中国是经RFPI授权在中国地区的官方代表机构，致力于用专业和品牌为中国理财师赋能。RFP中国经过近20年的发展，公司已经形成了以学习、评选、认证为核心业务，涵盖专业的理财教育和大众财商教育体系，理财精英峰会、福布斯中国保险精英评选暨福布斯中国保险峰会、第一财经·RFP理财精英评选暨中国理财师大会等三大行业盛事，以及理财人生沙盘游戏、福马仕等版权项目，努力为中国的理财行业发展做出积极的贡献。
          </p>
        </div>
      </div>
      <div class="search text-center">
        <el-card>
          <h2 class="part-title" style="font-size:18px">证书查询</h2>
          <br />
          <el-form :model="ruleForm" ref="ruleForm" label-width="110px">
            <el-form-item label="证书持有人姓名" prop="pass">
              <el-input
                v-model="ruleForm.name"
                size="mini"
                placeholder="请输入证书持有人姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号或身份证" prop="checkPass">
              <el-input
                v-model="ruleForm.search"
                size="mini"
                placeholder="请输入手机号或身份证"
              ></el-input>
            </el-form-item>
          </el-form>
          <span class="submit_btn" @click="submitForm">查询</span>
        </el-card>
      </div>
    </div>

    <el-dialog :visible.sync="tableShow" width="600px">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="80px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="证书名称">
          <template slot-scope="scope">
            {{ scope.row.title }}证书
            <!-- <span v-if="scope.row.type == 0">初级证书</span>
            <span v-if="scope.row.type == 1">中级证书</span> -->
          </template>
        </el-table-column>

        <el-table-column prop="" label="查看证书">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="url + '/outpdf/out/' + scope.row.numbers + '.jpg'"
              :preview-src-list="scope.row.srcList"
            >
            </el-image>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Normaltop from '../components/normaltop'
export default {
  name: 'CertInfo',
  components: { Normaltop },
  data() {
    return {
      img_url: require('../assets/image/cert/banner.png'),
      ruleForm: {},
      certImgShow: false,
      tableShow: false,
      tableData: [],
      imgUrl: '',
      url: process.env.VUE_APP_URLPOOL,
    }
  },
  created() {},
  methods: {
    submitForm() {
      let _this = this
      if (_this.ruleForm.name == '') {
        _this.$message.error('请输入证书持有人姓名')
        return false
      }
      if (_this.ruleForm.search == '') {
        _this.$message.error('请输入持有人手机号或身份证号')
        return false
      }
      _this.$http
        .post(process.env.VUE_APP_URL + 'cert', _this.ruleForm)
        .then(data => {
          if (data.data.code == 200) {
            if (data.data.data.length == 0) {
              _this.$message.error('未查询到证书')
            } else {
              _this.tableData = data.data.data
              _this.tableData.forEach(item => {
                item.srcList = []
                item.srcList.push(
                  _this.url + '/outpdf/out/' + item.numbers + '.jpg'
                )
              })
              _this.tableShow = true
            }
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(err => {
          _this.$message.error('网络错误，请重试')
          console.log(err)
        })
    },
  },
}
</script>
<style lang="less" scoped>
.certInfo {
  min-width: 1100px;

  img {
    width: 100%;
  }
  .guide-cont {
    position: relative;
    box-sizing: border-box;

    .part {
      width: 60%;
      margin: 0 auto;
      position: relative;
      // padding: 50px 0 10px;
    }
  }
}
.part-title {
  color: #000005;
  font-weight: bold;
  font-size: 28px;
  padding-bottom: 10px;
}
.part-h3 {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 15px;
}
.part-cont {
  padding-bottom: 16px;
  color: #666;
  font-size: 14px;
  line-height: 26px;
}

.cert {
  width: 60%;
  margin: 40px auto;
  // position: absolute;
  // top: 70px;
  // left: 25%;
}
.cert_btn {
  position: absolute;
  bottom: 50px;
  left: 25%;
  padding: 5px;
  color: #fe955e;
  border-radius: 4px;
  border: 1px solid #fe955e;
  background: #fff;
  font-size: 14px;
}
.el-card.is-always-shadow {
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
  border: none;
}
.search {
  width: 100%;
  background: url('../assets/image/cert/img3.png');
  background-size: 100% 100%;
  text-align: center;
  .el-card {
    width: 26%;
    margin: 40px auto;
    text-align: center;
  }
  .submit_btn {
    padding: 5px;
    color: #fff;
    border-radius: 4px;
    border: 1px solid #fe955e;
    background: #fd4a29;
    font-size: 14px;
    width: 100px;
    cursor: pointer;
    display: inline-block;
  }
}
.cert_container {
  // position: relative;
}
/deep/.el-form-item__label {
  line-height: 30px;
}
</style>
